<div class="goal-save-result-dialog">
  <div mat-dialog-title>
    <h1 id="goals-save-result-dialog">{{ 'Save Result' | translate }}</h1>
    <cl-btn
      mat-dialog-close
      icon="close"
      [label]="'close dialog' | translate"
      buttonStyle="alert small"
      class="course-assign-license-error-dialog__close" />
  </div>
  <div mat-dialog-content>
    <div class="goal-save-confirmation-dialog__info">
      @if (data.failures.length === 0) {
        <p class="line">
          {{
            'Success! The selected course has been assigned to all students in the class.'
              | translate
          }}
        </p>
        <p class="line">
          {{
            'Please note that the assignment has been made for all students currently rostered to this class.' +
              ' This will not automatically assign the course to any students if they transfer into this class.'
              | translate
          }}
        </p>
      } @else {
        <p class="line">
          {{
            'Due to limited license availability, not all of your changes were saved.' | translate
          }}
        </p>
        @if (data.successes.length > 0) {
          <p class="line">
            {{ 'The following students received the course assignment:' | translate }}
          </p>
          <div class="line">
            @for (studentName of studentNames; track studentName) {
              <div class="name">
                {{ studentName }}
              </div>
            }
          </div>
        }
        <p class="line">
          {{ 'The following students did NOT receive the course assignment:' | translate }}
        </p>
        <div class="line">
          @for (studentName of failureStudentNames; track studentName) {
            <div class="name">
              {{ studentName }}
            </div>
          }
        </div>
        <p class="line">
          {{
            'Please contact your administrator to ensure licensing needs are met. Courses can be both' +
              ' assigned and unassigned one by one in the students view.' | translate
          }}
        </p>
      }
    </div>
  </div>
  <div mat-dialog-actions>
    <cl-btn mat-dialog-close>{{ 'OK' | translate }}</cl-btn>
  </div>
</div>
